import React from "react";
import { DialogContent, Paper, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import useProviderDetail from "src/hooks/setting/provider/useProviderDetail";

export default function ProviderDetail({ item }) {
  const { data } = useProviderDetail(item?._id);

  const provider = data?.data;

  return (
    <DialogContent>
      <Paper
        variant="outlined"
        sx={{ borderRadius: 2, overflow: "hidden" }}
      >
        <Table>
          <TableHead>
            <TableRow
              sx={{
                bgcolor: "grey.100",
              }}
            >
              <TableCell
                sx={{
                  fontWeight: 600,
                  width: "35%",
                  borderBottom: "1px solid",
                  borderColor: "divider",
                }}
              >
                Thông tin
              </TableCell>

              <TableCell
                sx={{
                  fontWeight: 600,
                  borderBottom: "1px solid",
                  borderColor: "divider",
                }}
              >
                Giá trị
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            <TableRow>
              <TableCell>Nhà cung cấp</TableCell>
              <TableCell>{provider?.name || "-"}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>MST</TableCell>
              <TableCell>{provider?.taxCode || "-"}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>Địa chỉ</TableCell>
              <TableCell>{provider?.fullAddress ?? "-"}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>Số điện thoại</TableCell>
              <TableCell>{provider?.phone || "-"}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>Email</TableCell>
              <TableCell>{provider?.email || "-"}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Ghi chú</TableCell>
              <TableCell>{provider?.note || "-"}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Paper>
    </DialogContent>
  );
}
